import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { setReopenModal } from "actions/App";
import { fetchUnitList, transferUnit } from "actions/Units";
import TableNew from "components/TableNew";
import LoadingIndicator from "components/LoadingIndicator";
import ButtonContained from "components/ButtonContained";
import IconWithBackground from "components/IconWithBackground";

const UnitTransferModal = ({ unit }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const unitsList = useSelector(state => state.units.unitsList);
  const site = useSelector(state => state.auth.site);
  const [selectedUnit, setSelectedUnit] = useState(null);

  useEffect(() => {
    dispatch(fetchUnitList(["available"]));
  }, []);

  const handleSave = () => {
    dispatch(transferUnit(
      {
        unitUUID: unit.uuid,
        unitUUIDs: [unit.uuid, selectedUnit],
        userUUID: unit.User.uuid
      },
      {
        successMessage: intl.formatMessage({ id: "notifications.success.assign" }),
        facilityUUID: site.uuid,
        companyUUID: site.companyUUID
      }
    ));
  }

  return (
    unitsList ? <div className="space-y-2 px-10 min-h-[40vh] max-h-[70vh] flex flex-col">
      <div>
        <p className="tw-paragraph-sm">{intl.formatMessage({ id: "comp.button.transfer.unitDesc" })}</p>
      </div>
      <div>
        <span className="tw-paragraph-lg font-semibold">{intl.formatMessage({ id: "form.from" })}: {" "}</span>
        <span className="tw-paragraph-lg">{unit?.name}</span>
      </div>
      <div>
        <span className="tw-paragraph-reg font-semibold">{intl.formatMessage({ id: "form.user" })}: {" "}</span>
        <span className="tw-paragraph-reg">{unit?.User?.firstName} {unit?.User?.lastName}</span>
      </div>
      <div>
        <span className="inline-block tw-paragraph-reg font-semibold mb-4">{intl.formatMessage({ id: "db.transfer-smartentry" })} {intl.formatMessage({ id: "form.to" })}:</span>
        <TableNew
          data={unitsList}
          defaultSortKey="name"
          searchableKeys={["name"]}
          singleSelect={true}
          showHeaders={false}
          onSelectionChange={(unit) => setSelectedUnit(unit[0])}
          icon={<IconWithBackground
            iconName="closedDoor"
            backgroundColor="#E7E7E7"
            className="text-[var(--color-gray-300)]"
          />}
          maxHeight="max-h-[200px]"
          columns={[
            {
              key: "name",
              label: "Name",
              sortable: true
            },
          ]}
        />
      </div>
      <div className="flex gap-2 justify-start">
        <ButtonContained
          id="Unit-Transfer-Modal-Transfer-Unit-Button"
          dataCy="Unit-Transfer-Modal-Transfer-Unit-Button"
          text={intl.formatMessage({ id: "comp.button.transfer.unit" })}
          type="default"
          disabled={!selectedUnit}
          onClick={() => handleSave()}
        />
        <ButtonContained
          id="Unit-Transfer-Modal-Cancel-Button"
          dataCy="Unit-Transfer-Modal-Cancel-Button"
          text={intl.formatMessage({ id: "comp.button.cancel" })}
          type="defaultOutline"
          onClick={() => dispatch(setReopenModal({ unitUUID: unit.id }))}
        />
      </div>
    </div>
    : <div className="flex justify-center">
      <LoadingIndicator />
    </div>
  )
}

export default UnitTransferModal;